import type { GetServerSideProps } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getAccommodationsPointPage } from "@/_pages/accommodations/api";
import { SingleAccommodationsPointPage } from "@/_pages/accommodations/ui";

type Params = {
  slug: string;
};

type PageCms = Awaited<ReturnType<typeof getAccommodationsPointPage>>;

type PageProps = {
  cms: PageCms;
};

const Page = (props: PageProps) => {
  const { cms } = props;
  const { point, mapData } = cms || {};

  return <SingleAccommodationsPointPage point={point} mapData={mapData} />;
};

export const getServerSideProps: GetServerSideProps<
  Record<string, unknown>,
  Params
> = async (context) => {
  const { res } = context;
  const slug = context.params?.slug;

  if (!slug) {
    return { notFound: true };
  }

  return await loadPageWithGlobal(
    async () => {
      const { point, mapData, seo } = await getAccommodationsPointPage(slug);

      return {
        point,
        mapData,
        seo,
      };
    },
    { res },
  );
};

export default Page;
